import { NameDisplayPreference } from '../graphql/enum/name-display-preference.enum'

export const computeFullname = (nameDisplayPreference: string, firstName: string | undefined, lastName: string | undefined): string => {
  if (firstName && lastName && nameDisplayPreference && nameDisplayPreference === NameDisplayPreference.NAME_FIRST) {
    return firstName + ' ' + lastName
  } else if (firstName && lastName) {
    return lastName + ' ' + firstName
  } else {
    return ''
  }
}
